import { AxiosResponse } from 'axios';

export const prepareFilename = (response: AxiosResponse<BlobPart>, fallbackName: string) => {
  let filename = fallbackName;
  const disposition = response.headers['content-disposition'];
  const match = disposition && disposition.match(/filename\*?=(?:UTF-8''|")?([^;\n"]+)/);
  if (match) {
    filename = decodeURIComponent(match[1].trim());
  }
  return filename;
};